module.exports = __webpack_public_path__ + "static/media/slakteweb-icon@2x.bde53ca6.png";